import { industriesData } from "../staticData/industriesData";

/**
 * Retrieves the current industry card based on the provided type.
 * @param type The type of industry card to retrieve.
 * @returns The industry card matching the provided type, or the first industry card if not found.
 */
export const getCurrentIndustryCard = (type: string) => {
  return industriesData.find(({ path }) => path === type) || industriesData[0];
}